package xim.poc.game.event

import xim.poc.ActorId
import xim.poc.game.ActorStateManager
import xim.poc.game.StatusEffect

class ActorExpireStatusEvent(
    val actorId: ActorId,
    val statuses: List<StatusEffect>
): Event {

    override fun apply(): List<Event> {
        val actorState = ActorStateManager[actorId] ?: return emptyList()

        actorState.getStatusEffects()
            .filter { statuses.contains(it.statusEffect) }
            .forEach { actorState.expireStatusEffect(it.statusEffect) }

        return emptyList()
    }

}